/** @format */

import { Button } from "@material-ui/core"
import { Formik, Field } from "formik"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { InsertOwnerInfo, UploadFiles, GetDriverByNCode } from "../crud"
import { Input} from "../../../../_metronic/_partials/controls"
import { actions } from "../redux"
import * as Yup from "yup"
export default (props) => {
  const [successImages, setSuccessImages] = React.useState({
    count: 1,
    stats: "success",
  })
  const [nationalCodeErr1, setNationalCodeErr1] = React.useState(null);
  const [nationalCodeErr2, setNationalCodeErr2] = React.useState(null);
  const [submit1, setSubmit1] = React.useState(false);
  const [errorFirstDriver, setErrorFirstDriver] = React.useState(null);
  const [errorSecondDriver, setErrorSecondDriver] = React.useState(null);
  const [firstDriverNationalCode, setFirstDriverNationalCode] = React.useState(null);
  const [secondDriverNationalCode, setSecondDriverNationalCode] = React.useState(null);
  const [information1, setInformation1] = React.useState(null)
  const [information2, setInformation2] = React.useState(null)
  const phoneNumberValidation = /^09\d{9}$/
  const persianREGEX = /^[\u0600-\u06FF]+$/

  const dispatch = useDispatch()
  const ownerToken = useSelector((state) => state.token.token)
  const ownerState = useSelector((state) => state.owner)
  const { user } = useSelector((state) => state.auth)

  const CustomerEditSchema = Yup.object().shape({
    firstDriver: Yup.object({
      driverPhone: Yup.string()
        .matches(phoneNumberValidation, "فرمت شماره وارد شده اشتباه است")
        .required("پر کردن فیلد الزامی است"),
      driverNationalCode: Yup.string("فرمت وارد شده اشتباه است")
        .required("پر کردن فیلد الزامی است")
        // .test(
        //   "nationalCode",
        //   "کد ملی وارد شده معتبر نیست",
        //   isValidIranianNationalCode
        // )
        .typeError("فرمت وارد شده اشتباه است"),
    }).required("الزامی"),
    secondDriver: Yup.object({
      driverPhone: Yup.string()
        .matches(phoneNumberValidation, "فرمت شماره وارد شده اشتباه است")
        .required("پر کردن فیلد الزامی است"),
      driverNationalCode: Yup.string("فرمت وارد شده اشتباه است")
        .required("پر کردن فیلد الزامی است")
        // .test(
        //   "nationalCode",
        //   "کد ملی وارد شده معتبر نیست",
        //   isValidIranianNationalCode
        // )
        .typeError("فرمت وارد شده اشتباه است"),
    }).required("الزامی"),
  })
  let persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  let arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];

  const fixNumber = (str) => {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    } 
    return str;
  };

  function ValidateNID(code) {
    var str = code.toString();
  
    // validate the string length and value
    var strLen = str.length,
      strVal = parseInt(str);
    if (strLen < 8 || strLen > 10 || isNaN(strVal) || strVal == 0) return false;
  
    // make sure the string is padded with zeros
    while (str.length < 10) str = "0" + str;
  
    // invalidate consecutive arrangement of the same digit
    if (str.match(/^(\d)\1+$/g)) return false;
  
    var checkDigit = parseInt(str.slice(-1)), // rightmost digit
      str = str.slice(0, -1); // remove the check digit
  
    for (var sum = 0, i = str.length; i > 0; i--)
      sum += (i + 1) * str.substr(-i, 1);
  
    // calculate sum modulo 11
    var mod = sum % 11;
  
    return (
      (mod < 2 && mod === checkDigit) || (mod >= 2 && mod + checkDigit === 11)
    );
  }
  const handleNationalCode = (nationalCode) => {
  const params = {
    nationalCode: nationalCode,
    }
    return params
}


  return (
    <div className="p-5">
      <h2
        className="col-4 col-md-3"
        style={{
          borderBottom: "3px solid #6dd06d",
          padding: "10px",
          whiteSpace: "nowrap",
        }}
      >
        <b>مشخصات راننده</b>
      </h2>
      <Formik
        enableReinitialize
        validationSchema={CustomerEditSchema}
        initialValues={{ firstDriver: {}, secondDriver: {} }}
        // async
        onSubmit={async (values) => {
          console.log("drivers", values)
          values.firstDriver={
            ...values.firstDriver,
            firstname:information1?.name,
             lastName:information1?.family,
             smartCardNumber: information1?.no_kart,
             drivingLicenceNumber: information1?.shomare_gavahinameh,
             smartCardExpireDate:`${information1?.tarikh_payan_etebar.slice(0,4)}/${information1?.tarikh_payan_etebar.slice(4,6)}/${information1?.tarikh_payan_etebar.slice(6,8)}`,
             drivingLicenceExpireDate:information1?.certificate_end_date
            }
          values.secondDriver={
              ...values.secondDriver,
              firstname:information2?.name,
              lastName:information2?.family,
              smartCardNumber: information2?.no_kart,
              drivingLicenceNumber: information2?.shomare_gavahinameh,
              smartCardExpireDate:`${information2?.tarikh_payan_etebar.slice(0,4)}/${information2?.tarikh_payan_etebar.slice(4,6)}/${information2?.tarikh_payan_etebar.slice(6,8)}`,
              drivingLicenceExpireDate:information2?.certificate_end_date
            }
          console.log("drivers2", values)
          const newObj = {
            ...ownerState.ownerInfo,
            drivers: [values.firstDriver, values.secondDriver],
            acceptCondition: 1,
          }

          console.log("new Obj", newObj)

          dispatch(actions.getAllOwnerInfo(newObj))

          await InsertOwnerInfo(newObj, ownerToken).then((res) => {
            ownerState.images.map((data) => {
              const formData = new FormData()

              data.images.map((el) => {
                formData.append("images", el)
              })
              formData.append("contractDocTypeId", data.ContractDocTypeId)
              formData.append("title", data.title)
              formData.append("description", data.description)
              formData.append("contractId", res.data.contractId)
              UploadFiles(formData, ownerToken)
                .then((res) => {
                  setSuccessImages({
                    ...successImages,
                    count: successImages.count++,
                  })
                })
                .catch((err) => {
                  setSuccessImages({ ...successImages, stats: "failed" })
                })
            })
          })
          dispatch(actions.getAllOwnerInfo({}))
          dispatch(actions.getAllImages([]))
          props.handleComplete()
        }}
      >
        {({ handleSubmit, setFieldValue, errors, touched, values }) => {
          return (
            <div>
              <div>با تکمیل کردن فیلد کدملی و شماره تلفن و زدن گزینه استعلام اطلاعات به صورت خودکار تکمیل میشود.</div>
              <h4 className="col-12 mt-10 px-0" >
                راننده ۱
              </h4>
              <>
                <div className="row form-group mb-0">
                  <div className="col-lg-4">
                    <label htmlFor="">کدملی</label>
                    <Field
                      // variant="outlined"
                      // type="text"
                      // name="nationalCode"
                      // className="travelcontent-input"
                      // placeholder="کد ملی"
                      
                      onChange={(e) => {
                        const res = fixNumber(e.target.value);                        
                        if (ValidateNID(res)) {
                          setFieldValue("firstDriver.driverNationalCode", e.target.value)
                          setFirstDriverNationalCode(e.target.value)
                          setNationalCodeErr1(null);
                          setSubmit1(false)
                        } else {
                          setSubmit1(true)
                          setNationalCodeErr1("کد ملی وارد شده نادرست است");
                        }
                      }}
                      name="firstDriver.driverNationalCode"
                      component={Input}
                      placeholder="کد ملی"

                    />
                      {touched.firstDriver?.driverNationalCode &&
                        errors.firstDriver?.driverNationalCode ? (
                        <b className="text-danger mt-1">
                          {errors.firstDriver?.driverNationalCode}
                        </b>
                      ) : null}
                      {nationalCodeErr1 ? (
                        <p
                          className="mt-3"
                          style={{ fontSize: "14px", color: "red" }}
                        >
                          {nationalCodeErr1}
                        </p>
                      ) : null}
                  </div>
                  <div className="col-lg-4">
                    <label htmlFor="">شماره تلفن</label>
                    <Field
                      name="firstDriver.driverPhone"
                      component={Input}
                      placeholder="شماره موبایل"
                      // variant="outlined"
                      // type="text"
                      // name="phone"
                      // className="travelcontent-input"
                      // placeholder="شماره تلفن"
                      // onChange={(e) => {
                      //   setFieldValue("phone", e.target.value)
                      // }}
                    />
                  {touched.firstDriver?.driverPhone &&
                    errors.firstDriver?.driverPhone ? (
                    <b className="text-danger mt-1">
                      {errors.firstDriver?.driverPhone}
                    </b>
                  ) : null}
                  </div>
                  <div className="col-lg-4 d-flex align-items-center mt-8">
                    <Button
                      className="btn btn-primary"
                      // variant="primary"
                      style={{backgroundColor:"6dd06d"}}
                      onClick={() => 
                        {
                        GetDriverByNCode(handleNationalCode(firstDriverNationalCode))
                        .then(async (res) => {
                          setErrorFirstDriver(null)
                          setInformation1(res.data.driver )
                        })
                        .catch((error) => {
                            if(error.response.data.error?.driver)
                            {setErrorFirstDriver(error.response.data.error.driver)}
                            else
                            {setErrorFirstDriver(error.response.data.error)}
                        })}}
                    >
                      استعلام
                    </Button>
                  </div>
                </div>
                <b className="row form-group text-danger pl-5">{errorFirstDriver? errorFirstDriver:null}</b>
              
                <div className="mb-8">
                {!information1? null: (
                  <div>راننده اول، آقای {information1?.name} {information1?.family} با شماره گواهینامه {information1?.shomare_gavahinameh} می باشد.</div> )}
                </div>
              </>

              <h4 className="col-12 mt-10 px-0" >
                راننده ۲
              </h4>
              
            <>
              <div className="row form-group mb-0">
                <div className="col-lg-4">
                  <label htmlFor="">کدملی</label>
                  <Field
                    // variant="outlined"
                    // type="text"
                    // name="nationalCode"
                    // className="travelcontent-input"
                    // placeholder="کد ملی"
                    onChange={(e) => {
                      const res = fixNumber(e.target.value);                        
                      if (ValidateNID(res)) {
                        setFieldValue("secondDriver.driverNationalCode", e.target.value)
                        setSecondDriverNationalCode(e.target.value)
                        setNationalCodeErr2(null);
                        setSubmit1(false)
                      } else {
                        setSubmit1(true)
                        setNationalCodeErr2("کد ملی وارد شده نادرست است");
                      }
                    }}
                    name="secondDriver.driverNationalCode"
                    component={Input}
                    placeholder="کد ملی"

                  />
                    {touched.secondDriver?.driverNationalCode &&
                      errors.secondDriver?.driverNationalCode ? (
                      <b className="text-danger mt-1">
                        {errors.secondDriver?.driverNationalCode}
                      </b>
                    ) : null}
                    {nationalCodeErr2 ? (
                      <p
                        className="mt-3"
                        style={{ fontSize: "14px", color: "red" }}
                      >
                        {nationalCodeErr2}
                      </p>
                    ) : null}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="">شماره تلفن</label>
                  <Field
                    name="secondDriver.driverPhone"
                    component={Input}
                    placeholder="شماره موبایل"
                    // variant="outlined"
                    // type="text"
                    // name="phone"
                    // className="travelcontent-input"
                    // placeholder="شماره تلفن"
                    // onChange={(e) => {
                    //   setFieldValue("phone", e.target.value)
                    // }}
                  />
                {touched.secondDriver?.driverPhone &&
                  errors.secondDriver?.driverPhone ? (
                  <b className="text-danger mt-1">
                    {errors.secondDriver?.driverPhone}
                  </b>
                ) : null}
                </div>
                <div className="col-lg-4 d-flex align-items-center mt-8">
                  <Button
                    className="btn btn-primary"
                    // variant="primary"
                    style={{backgroundColor:"6dd06d"}}
                    onClick={() => 
                      GetDriverByNCode(handleNationalCode(secondDriverNationalCode))
                      .then(async (res) => {
                        setErrorSecondDriver(null)
                        setInformation2(res.data.driver )
                      })
                      .catch((error) => {
                          if(error.response.data.error?.driver)
                          {setErrorSecondDriver(error.response.data.error.driver)}
                          else
                          {setErrorSecondDriver(error.response.data.error)}
                      })}
                  >
                    استعلام
                  </Button>
                </div>
              </div>
              <b className="row form-group text-danger pl-5">{errorSecondDriver? errorSecondDriver:null}</b>
            
              <div className="mb-8">
              {!information2? null: (
                <div>راننده دوم، آقای {information2?.name} {information2?.family} با شماره گواهینامه {information2?.shomare_gavahinameh} می باشد.</div> )}
              </div>
            </>

              <div
                className="d-flex align-items-center flex-wrap col-12"
                style={{ marginBlock: "3rem 2rem" }}
              >
                <div className="col-12 col-md-6 p-1 my-3">
                  <Button
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#6dd06d",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    <h6 className="my-auto text-white">مرحله بعد</h6>
                  </Button>
                </div>
                <div className="col-12 col-md-6 p-1 my-3">
                  <Button
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#d9d9d9",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      props.handleBack()
                    }}
                  >
                    <h6 className="my-auto text-white">بازگشت</h6>
                  </Button>
                </div>
              </div>
            </div>
          )
        }}
      </Formik>
    </div>
  )
}
